exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vertical-text[data-v-33cec6cf] {\n  writing-mode: vertical-rl;\n  text-orientation: upright;\n}", ""]);

// exports
